import type {
  Configuration,
  CreateOrganizationIdpRequest,
  UpdateOrganizationIdpRequest,
} from '@repo/api-gw-sdk';
import { OrganizationsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/organization';

export const organizations = (
  httpClient: HttpClient,
  config: Configuration
) => {
  const organizationsApi = new OrganizationsApi(config);

  return {
    accounts: {
      useList: () =>
        httpClient.execute(
          organizationsApi.listOrganizationAccounts.bind(organizationsApi),
          baseUrl,
          '/accounts/list'
        ),
    },
    idps: {
      useList: () =>
        httpClient.execute(
          organizationsApi.listOrganizationIdps.bind(organizationsApi),
          baseUrl,
          '/idps/list'
        ),
      create: (idp: CreateOrganizationIdpRequest) =>
        organizationsApi.createOrganizationIdp(idp),
      update: (idpId: string, idp: UpdateOrganizationIdpRequest) =>
        organizationsApi.updateOrganizationIdp(idpId, idp),
      delete: (idpId: string) => organizationsApi.deleteOrganizationIdp(idpId),
      useServiceProviderDetails: () =>
        httpClient.execute(
          organizationsApi.getOrganizationServiceProviderDetails.bind(
            organizationsApi
          ),
          baseUrl,
          '/idps/service-provider-details'
        ),
    },
  };
};
